import React from 'react'
import {
  ListContainer,
  Container,
  TextBody,
  TextTitle
} from '@pmi/pmi-iqos-ds-react'
import { SelectableOption } from '@iqosphere-common/components'

const SelectionManager = ({ selectOptionHandler, optionsState, hasImages }) => {
  return optionsState.map((optionState, optionStateIndex) => {
    return (
      <Container
        key={optionState.id}
        pb={optionsState.length === optionStateIndex + 1 ? '0' : '8'}>
        <Container
          pb="5"
          display={Container.displays.flex}
          justifyContent={Container.justifyContentValues.center}>
          <TextTitle heading={TextTitle.headings.h3}>
            {optionState.subTitle}
          </TextTitle>
        </Container>

        <ListContainer
          fullWidth={true}
          columns={[1, hasImages ? 4 : 2]}
          yBetween="4"
          xBetween="4"
          form={true}>
          {optionState.options.map((option, optionIndex) => {
            return (
              <SelectableOption
                key={option.id}
                option={option.label}
                optionIndex={optionIndex}
                isSelected={option.selected}
                onClickHandler={() =>
                  selectOptionHandler(optionState.id, option.id)
                }
                image={option.image}
              />
            )
          })}
        </ListContainer>
        {(optionState.hasOptionsSelected || []).map((e, i) => {
          return (
            <Container key={i} pt="1" fullWidth>
              <TextBody size={TextBody.sizes.xs} style={TextBody.styles.error}>
                {e}
              </TextBody>
            </Container>
          )
        })}
      </Container>
    )
  })
}

export default SelectionManager
